import { Injectable } from '@angular/core';

import { obrigacoesStorage } from "./data.service";

@Injectable()
export class Obrigacoeservice {

  constructor() { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(obrigacoesStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(obrigacoesStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(obrigacoesStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {

  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/shared/obrigacao.service.ts
 **/